/**
 * Modales con modales comerciales
 *
 * Incluir las modales correspondientes:
 *
 * @include('modals.business.donate-now')
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 *
 */

const Business =
     {
        data :
             {
                // Modal de información sobre donaciones
                donateNowInfo :
                    {
                        // Entre 5 y 20 segundos para abrir la modal
                        timeout         : 5000 + Math.random() * 20000,

                        // Tiempo del temporizador de cuenta atrás antes de poder cerrar la modal
                        timeCanClose    : 0,

                        // Si la modal puede ser cerrada o no
                        canClose        : false,

                        // Porcentaje de incordio
                        // Cuanto más cercano a 100, con mayor frecuencia se mostrará la ventana informativa
                        //
                        // Este valor es cargado desde la configuración
                        //
                        // @see config/donations.php
                        //
                        nuisance        : 0,
                    },
             },
        /**
         * Cuando la instancia está montada
         *
         */
        mounted: function () {

            // Carga el usuario
            this.loadUser();

            // Carga la información de la modal de donaciones
            this.loadDonationInfo();

            /**
             * Si el usuario no está registrado o no es donante y se cumple con el grado de "incordio" requerido,
             * se espera un tiempo antes de abrir la modal de información sobre donaciones
             */
            if ((this.user == null || !this.user.donator) && Math.random() * 100 < this.donateNowInfo.nuisance)  {
                setTimeout(() => {
                    //
                    // Muestra la modal
                    //
                    new bootstrap.Modal( this.$refs.donationInfo, {
                        backdrop : 'static',
                        keyboard : false,
                    }).show();

                    //
                    // Actualiza la barra de progreso antes de
                    // mostrar el botón y el enlace de cierre
                    //
                    setInterval(() => {
                        if (this.donateNowInfo.timeCanClose <= 0) {
                            this.donateNowInfo.timeCanClose = 0;
                            this.donateNowInfo.canClose     = true;
                        } else {
                            this.donateNowInfo.timeCanClose-= 1000;
                        }
                    }, 1000);

                }, this.donateNowInfo.timeout);
            }
        },
        methods : {
            /**
             * Carga la información del usuario
             *
             */
            loadUser: function () {

                if (typeof user !== 'undefined') {
                    this.user = JSON.parse(user.value);
                }
            },
            /**
             * Carga la información de donaciones
             *
             */
        loadDonationInfo: function () {
            if (!this.$refs.donationInfo) return;

            // Carga el grado de incordio frecuencia con la que se muestra la petición de donación
            this.donateNowInfo.nuisance = this.$refs.donationInfo.dataset.nuisance;
            // El tiempo antes de que se pueda cerrar la modal
            this.donateNowInfo.timeCanClose = this.$refs.donationInfo.dataset.timeCanClose;
        },
        },
     };

module.exports = Business;
